




















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import BaseItem from './../../../../components/base/Item.vue';
import OcgItemGroup from './../ItemGroup.vue';

@Component({
  components: {
    BaseItem,
    OcgItemGroup,
  },
})
export default class DashboardCoreDrawer extends Vue {

  // Makes a "expandOnHover" a component prop with the default value of false
  @Prop({default: false})
  expandOnHover: boolean = false;

  showMainLogo: boolean = true;
  miniVariant: boolean = false;

  items = [
    {
      icon: this.$store.getters['app/icons'].dashboard,
      title: 'My Dashboard',
      to: '/',
    },
    {
      icon: this.$store.getters['app/icons'].profile,
      title: 'My Profile',
      to: '/profile',
    },
    {
      title: 'Job Library',
      icon: this.$store.getters['app/icons'].library,
      to: '/job-library',
    },    
    {
      // active: (this.$route.path.startsWith('/hardware')),
      group: '',
      icon: this.$store.getters['app/icons'].drawerTools,
      title: 'Tools',
      children: [
        {
          title: 'Tools & Resources',
          icon: this.$store.getters['app/icons'].generalTools,
          to: 'general-tools',
        },
        {
          title: 'Learners',
          icon: this.$store.getters['app/icons'].learners,
          to: 'learners',
        },
        {
          title: 'Students',
          icon: this.$store.getters['app/icons'].students,
          to: 'student-tools',
        },
        {
          title: 'Employed',
          icon: this.$store.getters['app/icons'].employed,
          to: 'employed',
        },
        {
          title: 'Unemployed',
          icon: this.$store.getters['app/icons'].unemployed,
          to: 'unemployed',
        },
      ],
    },
    {
      // active: (this.$route.path.startsWith('/hardware')),
      group: '',
      icon: this.$store.getters['app/icons'].search,
      title: 'Search',
      children: [
        {
          title: 'Qualifications',
          icon: this.$store.getters['app/icons'].qualification,
          to: 'qualifications',
        },
        {
          title: 'Tertiary Institutions',
          icon: this.$store.getters['app/icons'].institution,
          to: 'tertiary',
        },
        {
          title: 'Subjects',
          icon: this.$store.getters['app/icons'].subjects,
          to: 'subject',
        },
      ],
    },      
  ];

  @Watch('$vuetify.breakpoint.smAndDown')
  myFunction(newVal: string, oldVal: string) {
      this.$emit('update:expandOnHover', !newVal);
  }

  doTransitioned() {
    this.showMainLogo = !this.miniVariant;
    this.$root.$emit('update:mini-variant');
  }

  get computedItems() {
    return this.items.map(this.mapItem);
  }


  mapItem(item: any) {
    return {
      ...item,
      children: item.children ? item.children.map(this.mapItem) : undefined,
      title: item.title,
    };
  }

  getMobileLogoUrl() {
    return require('../../../../assets/ocglogo.png');
  }

  getDesktopLogoUrl() {
    return require('../../../../assets/ocglogo.png');
  }


}
